import { lazy, Suspense } from 'react';
import type { RouteObject } from 'react-router-dom';
import NotFound from '@/pages/NotFound';
import Home from '@/pages/home/page';

// ─── Lazy-loaded pages ────────────────────────────────────────────────────────
const Products      = lazy(() => import('@/pages/products/page'));
const ProductDetail = lazy(() => import('@/pages/products/detail'));
const CategoryPage  = lazy(() => import('@/pages/category/page'));
const Checkout      = lazy(() => import('@/pages/checkout/page'));
const About         = lazy(() => import('@/pages/about/page'));
const Contact       = lazy(() => import('@/pages/contact/page'));
const Terrazas      = lazy(() => import('@/pages/servicios/terrazas/page'));
const Paneles       = lazy(() => import('@/pages/servicios/paneles/page'));
const Seguridad     = lazy(() => import('@/pages/servicios/seguridad/page'));
const Electrico     = lazy(() => import('@/pages/servicios/electrico/page'));

// ─── Shared loading fallback ──────────────────────────────────────────────────
function PageLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="flex flex-col items-center gap-4">
        <div className="w-10 h-10 rounded-full border-2 border-primary-100 border-t-primary-600 animate-spin" />
        <span className="text-xs text-content-tertiary font-medium tracking-wide">Cargando...</span>
      </div>
    </div>
  );
}

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/products',
    element: (
      <Suspense fallback={<PageLoader />}>
        <Products />
      </Suspense>
    ),
  },
  {
    path: '/category/:name',
    element: (
      <Suspense fallback={<PageLoader />}>
        <CategoryPage />
      </Suspense>
    ),
  },
  {
    path: '/products/:id',
    element: (
      <Suspense fallback={<PageLoader />}>
        <ProductDetail />
      </Suspense>
    ),
  },
  {
    path: '/checkout',
    element: (
      <Suspense fallback={<PageLoader />}>
        <Checkout />
      </Suspense>
    ),
  },
  {
    path: '/about',
    element: (
      <Suspense fallback={<PageLoader />}>
        <About />
      </Suspense>
    ),
  },
  {
    path: '/contact',
    element: (
      <Suspense fallback={<PageLoader />}>
        <Contact />
      </Suspense>
    ),
  },
  {
    path: '/servicios/terrazas',
    element: (
      <Suspense fallback={<PageLoader />}>
        <Terrazas />
      </Suspense>
    ),
  },
  {
    path: '/servicios/paneles',
    element: (
      <Suspense fallback={<PageLoader />}>
        <Paneles />
      </Suspense>
    ),
  },
  {
    path: '/servicios/seguridad',
    element: (
      <Suspense fallback={<PageLoader />}>
        <Seguridad />
      </Suspense>
    ),
  },
  {
    path: '/servicios/electrico',
    element: (
      <Suspense fallback={<PageLoader />}>
        <Electrico />
      </Suspense>
    ),
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
